import React from 'react';
import { hot } from 'react-hot-loader/root';

import { BrowserRouter as Router, Route } from 'react-router-dom';

import { BASE_ROUTE } from './config/consts';
import './styles/scss/index.scss';
import App from './ui/containers/App';

// import configureStore from './redux';
// import initialState from './redux/state';
// import { saveState } from './redux/store-persist';

// const store = configureStore(initialState);

// store.subscribe(() => {
//     saveState(store.getState());
// });

const Root = () => (
    <Router>
        <Route path={BASE_ROUTE}>
            <App />
        </Route>
    </Router>
);

export default hot(Root);
